class ExpiredModal {
  constructor() {
    this.modal = document.querySelector('.expired-modal');

    if (this.modal) {
      this.onLoad();
      const buttons = this.modal.querySelectorAll('.expired-modal__btn-red');
      if (buttons) buttons.forEach(btn => {
        btn.onclick = () => {
          this.close()
        };
      })
    }
  }

  onLoad() {
    $.request('UserData::onCheckShowExpired', {
      success: (data) => {
        if (typeof data === 'object' && data.date) {
          const date = new Date(data.date)
          this.modal.querySelector('.expired-modal__text .bold').innerText = date.toLocaleString('ru', {
            year: "numeric", month: "numeric", day: "numeric",
          })
          this.modal.querySelector('.subscription-name').innerText = '"' + data.product + '"';
          this.modal.classList.add('show')
        }
      }
    })
  }

  close() {

    $.request('UserData::onRemoveShowExpired', {
      success: () => {
        this.modal.classList.remove('show')
        this.onLoad();
      }
    })
  }
}

export default new ExpiredModal();
